export default __webpack_public_path__ + "static/media/stackdriver-trace.1aeb76e7.svg";